import React, { useState } from 'react';
import { FacturacionDataProvider, useFacturacionData } from '../../../context/FacturacionContext';

import FacturasEmitidasTab from './Tabs/FacturasEmitidasTab';
import GastosComprasTab from './Tabs/GastosComprasTab';
import MaestrosFinanzasTab from './Tabs/MaestrosFinanzasTab';
import ReportesFinanzas from './ReportesFacturacion/ReportesFinanzas';
import CalendarioPagosTab from './Tabs/CalendarioPagosTab';
import PageHeader from '../../cpanel/PageHeader';

const FacturacionGestionContent = () => {
    const [selectedModule, setSelectedModule] = useState(null); // null | 'facturas' | 'gastos' | 'balance' | 'maestros' | 'calendario'

    const { facturacionMasters, loadingFacturacionMasters } = useFacturacionData();

    const modules = [
        {
            id: 'facturas',
            title: 'Facturas Emitidas',
            description: 'Ventas, cobros de comisiones, retenciones e ingresos a banco.',
            actionText: 'Acceder',
            icon: (
                <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
            ),
            hoverBorder: 'hover:border-emerald-300'
        },
        {
            id: 'gastos',
            title: 'Gastos y Compras',
            description: 'Egresos, compras operativas, IVA crédito fiscal y débitos.',
            actionText: 'Acceder',
            icon: (
                <svg className="w-6 h-6 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
            ),
            hoverBorder: 'hover:border-rose-300'
        },
        {
            id: 'calendario',
            title: 'Calendario de Pagos',
            description: 'Monitoreo de vencimientos, agenda de egresos y cambio de estados.',
            actionText: 'Ver Agenda',
            icon: (
                <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
            ),
            hoverBorder: 'hover:border-amber-300'
        },
        {
            id: 'balance',
            title: 'Balance y Reportes',
            description: 'P&L, posición neta de IVA y saldo consolidado de bancos.',
            actionText: 'Acceder',
            icon: (
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
            ),
            hoverBorder: 'hover:border-indigo-300'
        },
        {
            id: 'maestros',
            title: 'Tablas Maestras',
            description: 'ABM de Clientes, Proveedores, Cuentas, Áreas y Conceptos.',
            actionText: 'Configurar',
            icon: (
                <svg className="w-6 h-6 text-slate-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            ),
            hoverBorder: 'hover:border-slate-300'
        }
    ];

    // Helper condicional que sólo entrega props para el Home, Maestros y Calendario
    const getHeaderProps = () => {
        if (!selectedModule) {
            return {
                title: "Centro de Gestión Financiera & Facturación",
                subtitle: "Selecciona el centro de control financiero",
                backTo: "/cpanel"
            };
        }
        if (selectedModule === 'maestros') {
            return {
                title: "Tablas Maestras de Finanzas",
                subtitle: "ABM de Clientes, Proveedores, Cuentas, Áreas y Conceptos",
                onBackClick: () => setSelectedModule(null)
            };
        }
        if (selectedModule === 'calendario') {
            return {
                title: "Agenda y Calendario de Pagos",
                subtitle: "Monitoreo de vencimientos de egresos y control de estados de pago",
                onBackClick: () => setSelectedModule(null)
            };
        }
        return null; // En los demás casos (Facturas, Gastos, Balance) NO se dibuja PageHeader
    };

    if (loadingFacturacionMasters) {
        return (
            <div className="h-screen w-screen flex flex-col items-center justify-center bg-[#f3f4f8] space-y-4">
                <div className="w-12 h-12 border-4 border-indigo-600/20 border-t-indigo-600 rounded-full animate-spin"></div>
                <span className="text-xs font-black uppercase tracking-widest text-indigo-900">Sincronizando Módulo Financiero...</span>
            </div>
        );
    }

    const headerProps = getHeaderProps();

    return (
        <div className="h-screen w-screen max-h-screen max-w-full overflow-hidden bg-[#f3f4f8] font-sans text-slate-800 text-left flex flex-col antialiased">
            <div className="h-screen bg-[#f3f4f8] flex flex-col">
                
                {/* 🎯 PageHeader CONDICIONAL EXCLUSIVO SÓLO PARA HOME, MAESTROS Y CALENDARIO */}
                {headerProps && (
                    <PageHeader 
                        title={headerProps.title}
                        subtitle={headerProps.subtitle}
                        backTo={headerProps.backTo}
                        onBackClick={headerProps.onBackClick}
                        rightContent={
                            <span className="bg-indigo-50 text-indigo-700 text-[10px] font-black px-3 py-1 rounded-full border border-indigo-200 uppercase tracking-wider hidden sm:inline-block">
                                Finanzas Pro
                            </span>
                        }
                    />
                )}

                {/* CONTENIDO PRINCIPAL */}
                <main className="flex-grow w-full overflow-hidden flex flex-col relative">
                    
                    {/* MENÚ LANDING DE TARJETAS (HOME) */}
                    {!selectedModule && (
                        <div className="w-full h-full overflow-y-auto px-48 pt-14 pb-16">
                            <div className="max-w-[1600px] mx-auto space-y-6">
                                
                                <div className="flex items-center justify-between border-b border-slate-200/80 pb-4">
                                    <div>
                                        <h2 className="text-2xl font-bold text-slate-900 tracking-tight">
                                            Módulos Financieros
                                        </h2>
                                        <p className="text-sm text-slate-400 font-normal mt-1">
                                            Administración de ingresos, compras, vencimientos y reportes contables
                                        </p>
                                    </div>
                                    <span className="bg-blue-50 text-blue-700 text-[10px] font-black px-3 py-1 rounded-full border border-blue-200 uppercase tracking-wider">
                                        {modules.length} Módulos
                                    </span>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                    {modules.map((item) => (
                                        <div 
                                            key={item.id}
                                            onClick={() => setSelectedModule(item.id)}
                                            className={`group bg-white border border-slate-200/80 ${item.hoverBorder} rounded-2xl p-5 transition-all duration-200 flex flex-col justify-between h-full shadow-2xs hover:shadow-xl hover:-translate-y-1 cursor-pointer`}
                                        >
                                            <div>
                                                <div className="flex items-center justify-between mb-4">
                                                    <div className="p-2.5 rounded-xl bg-slate-50 border border-slate-100 group-hover:bg-white transition-colors">
                                                        {item.icon}
                                                    </div>
                                                </div>

                                                <h4 className="text-lg font-bold text-slate-900 group-hover:text-blue-600 transition-colors tracking-tight">
                                                    {item.title}
                                                </h4>

                                                <p className="text-slate-400 text-xs leading-relaxed font-medium mt-1.5">
                                                    {item.description}
                                                </p>
                                            </div>

                                            <div className="mt-5 pt-3 border-t border-slate-100 flex items-center justify-between text-xs font-bold text-slate-400 group-hover:text-blue-600 transition-colors">
                                                <span className="text-[11px] uppercase tracking-wider font-extrabold">{item.actionText}</span>
                                                <span className="transform group-hover:translate-x-1.5 transition-transform text-sm">→</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                    )}

                    {/* VISTAS DE MÓDULOS */}
                    {selectedModule === 'facturas' && (
                        <FacturasEmitidasTab 
                            maestros={{ ...facturacionMasters, conceptos: facturacionMasters.conceptosFacturas }}
                            onBack={() => setSelectedModule(null)}
                        />
                    )}
                    {selectedModule === 'gastos' && (
                        <GastosComprasTab 
                            maestros={{ ...facturacionMasters, conceptos: facturacionMasters.conceptosGastos }} 
                            onBack={() => setSelectedModule(null)}
                        />
                    )}
                    {selectedModule === 'balance' && (
                        <ReportesFinanzas 
                            maestros={facturacionMasters} 
                            onBack={() => setSelectedModule(null)}
                        />
                    )}
                    {selectedModule === 'calendario' && (
                        <CalendarioPagosTab 
                            maestros={{ ...facturacionMasters, conceptos: facturacionMasters.conceptosGastos }} 
                            onBack={() => setSelectedModule(null)}
                        />
                    )}
                    {selectedModule === 'maestros' && (
                        <MaestrosFinanzasTab 
                            onBack={() => setSelectedModule(null)}
                        />
                    )}

                </main>
            </div>
        </div>
    );
};

const FacturacionGestionPage = () => {
    return (
        <FacturacionDataProvider>
            <FacturacionGestionContent />
        </FacturacionDataProvider>
    );
};

export default FacturacionGestionPage;